import React, { useState } from 'react';
import { Mail } from 'lucide-react';
import DeliverySettings from './DeliverySettings';

const TABS = [
  { id: 'email', label: 'Email Delivery', icon: Mail },
  // Future: { id: 'whatsapp', label: 'WhatsApp', icon: MessageCircle },
  // Future: { id: 'notifications', label: 'Notifications', icon: Bell },
];

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('email');

  return (
    <div className="min-h-screen bg-[#F7F9FB] p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-slate-800 mb-1">Settings</h1>
        <p className="text-slate-500 text-sm mb-8">Configure delivery channels and integrations for your account</p>

        <div className="flex gap-6">
          {/* Sidebar nav */}
          <div className="w-48 shrink-0">
            <nav className="space-y-1">
              {TABS.map(({ id, label, icon: Icon }) => (
                <button
                  key={id}
                  onClick={() => setActiveTab(id)}
                  className={`w-full flex items-center gap-2.5 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors text-left ${
                    activeTab === id
                      ? 'bg-meraki-indigo text-white'
                      : 'text-slate-600 hover:bg-white hover:shadow-sm'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {label}
                </button>
              ))}
            </nav>
          </div>

          {/* Content */}
          <div className="flex-1 bg-white rounded-2xl shadow-sm border border-slate-100 p-6">
            {activeTab === 'email' && <DeliverySettings />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
